<script lang="ts">
	import validator from 'validator';
	import type { InputEmailProps } from '../types';
	import InputInline from '../InputInline.svelte';
	import { t } from 'svelte-i18n';
	import { undefOrNull } from '$lib/utils/objects';
	import isEmpty = validator.isEmpty;
	import isEmail = validator.isEmail;

	export let props: InputEmailProps;

	const checkEmail = (v: string) => undefOrNull(v) || isEmpty(v) || isEmail(v);

	if (props) {
		props.validation = props.validation ?? { rules: [] };
		props.validation = {
			...props.validation,
			rules: [
				...props.validation.rules,
				{
					label: $t('forms.validators.email'),
					check: checkEmail
				}
			]
		};
	}
</script>

<InputInline type="email" bind:props on:focus />
